export default __webpack_public_path__ + "static/Shwedagon-Pagoda-0360705806f8b89daf93f7e9d9d50416.jpg";